var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLiveClass(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 19.229,
    viewBox: "0 0 22 19.229",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{opacity:0.7;}.b{fill:#fff;}.c{fill:none;stroke:#fff;stroke-linecap:round;stroke-miterlimit:10;stroke-width:2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(1 1.392)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 2.297,
    cy: 2.297,
    r: 2.297,
    transform: "translate(7.703 5.926)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M377.451,307.59a10,10,0,0,0,0,16.446",
    transform: "translate(-373.142 -307.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M377.891,309.639a6.343,6.343,0,0,0-.606,9.5",
    transform: "translate(-371.769 -306.465)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M385.346,307.59a10,10,0,0,1,0,16.446",
    transform: "translate(-369.655 -307.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M384.279,309.639a6.345,6.345,0,0,1,.606,9.5",
    transform: "translate(-370.4 -306.465)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiveClass);
export default __webpack_public_path__ + "static/media/live-class.689b9f23cb78e94a1b1be4a616843109.svg";
export { ForwardRef as ReactComponent };